import { GroupType } from '../../clubhouse/models/group-type';
import { NotificationFlagsCategories } from '../../models/NotificationFlags/NotificationFlagsCategories';

export class PmgPocChatNotificationFlagsHelper {
    public static generateNotificationFlag = (
        groupType: GroupType,
        groupId: number,
        discussionId: number,
        customPrefix?: string
    ) => {
        switch (groupType) {
            case GroupType.PMG:
                return `${NotificationFlagsCategories.PmgCode}.${groupId}.${NotificationFlagsCategories.ClubBoardCode}.${discussionId}`;
            case GroupType.MP:
                return `${customPrefix}.${discussionId}`;
            default:
                return `${NotificationFlagsCategories.PocCode}.${discussionId}`;
        }
    };
}
